/** Matches tickers like "[NASDAQ: AXTI]", "(NYSE: AAPL)", "NASDAQ: MSFT" */
export const STOCK_TICKER_REGEX =
	/\[?(?:NASDAQ|NYSE|AMEX|OTCPK):\s*([A-Z]+)]?/i;

export function extractStockSymbol(text) {
	if (!text) return null;
	const matches = String(text).match(STOCK_TICKER_REGEX);
	return matches?.[1]?.toUpperCase() ?? null;
}

/**
 * WordPress often wraps heading text in nested spans with inline styles, e.g.
 * <h3><span id="..."><span style="font-weight:400">Name [NASDAQ: TICK]</span></span></h3>
 */
export function headingHasUnwantedInlineNesting($, headingEl) {
	const $h = $(headingEl);

	if ($h.find("[style]").length > 0) {
		return true;
	}

	if ($h.find("a").length > 0) {
		return false;
	}

	return $h.children("span, font").length > 0;
}

export function flattenHeading($, headingEl) {
	const text = $(headingEl).text().replace(/\s+/g, " ").trim();
	if (text) {
		$(headingEl).text(text);
	}
}

/**
 * Scan h1–h6 for referenced tickers, flatten unwanted inline nesting, and
 * invoke `onSymbol` for each unique ticker found.
 */
export function processHeadingsForReferencedStocks($, onSymbol) {
	$("h1, h2, h3, h4, h5, h6").each((_, headingEl) => {
		const text = $(headingEl).text();
		const symbol = extractStockSymbol(text);

		if (symbol) {
			onSymbol(symbol);
		}

		if (symbol || headingHasUnwantedInlineNesting($, headingEl)) {
			flattenHeading($, headingEl);
		}
	});
}
